export default "__VITE_ASSET__f3725ce2__"